import React from "react";
import { useNavigate } from "react-router-dom";
import { Popover } from "antd";

import { Images } from "../../config";

import "./styles.css";

const ExploreCard = (props) => {
  const navigate = useNavigate();

  const data = props.data;

  const popoverContent = (
    <div className="w-[14.375em] h-[9.675em] rounded-lg">
      <div
        className="w-full h-[6.35em] rounded-t-lg relative"
        style={{
          background: `url(${data?.campusPic ?? Images.DefaultUniCover})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black opacity-40 rounded-t-lg"></div>
        <div className="relative p-2 flex flex-col gap-1  text-white h-full justify-end">
          <img
            src={data?.profilePic ?? Images.LogoIconOnly}
            className="h-[2.25em] w-[2.25em] border border-searchBorder shadow-boxContainer rounded-full object-contain bg-white cursor-pointer"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = Images.LogoIconOnly;
            }}
            onClick={(event) => {
              if (event.ctrlKey) {
                window.open(`/universities/${data.id}`, "_blank");
              } else {
                navigate(`/universities/${data.id}`);
              }
            }}
          />

          <div
            className="cursor-pointer font-semibold text-[0.875em] line-clamp-2 text-ellipsis"
            onClick={(event) => {
              if (event.ctrlKey) {
                window.open(`/universities/${data.id}`, "_blank");
              } else {
                navigate(`/universities/${data.id}`);
              }
            }}
          >
            {data?.name}
          </div>
        </div>
      </div>
      <div className="flex flex-col p-2 py-1 gap-1">
        <div className="grid-popover-value-container">
          <div>Acceptance Rate:</div>
          <div className="explore-popover-value">
            {(data?.acceptanceRate * 100).toFixed(1)}%
          </div>
        </div>
        <div className="grid-popover-value-container">
          <div>Application Status:</div>
          {data?.deadlines?.length > 0 ? (
            data?.deadlines[0]?.appDeadline ? (
              new Date() > new Date(data?.deadlines[0]?.appDeadline) ? (
                <span className="bg-red-500 text-white font-medium px-1 pt-0.5 pb-0.25 rounded-md ml-1 text-[0.765em]">
                  CLOSED
                </span>
              ) : (
                <span className="bg-green-500 text-white font-medium px-1 pt-0.5 pb-0.25 rounded-lg ml-1 text-[0.765em]">
                  OPEN
                </span>
              )
            ) : (
              "NA"
            )
          ) : (
            "NA"
          )}
        </div>
      </div>
    </div>
  );
  return (
    <Popover
      content={popoverContent}
      trigger={"hover"}
      arrow={false}
      overlayInnerStyle={{
        position: "absolute",
        padding: "0px",
        top: props?.top ?? "-9.975em",
        right: props?.right ?? "-7.1875em",
      }}
      onOpenChange={props.setIsPopoverOpen}
      getPopupContainer={(trigger) => trigger.parentElement}
    >
      <div>
        <div
          className="w-[14.375em] h-[9.675em] rounded-lg relative"
          style={{
            background: `url(${data?.campusPic ?? Images.DefaultUniCover})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 bg-black opacity-40 rounded-lg"></div>
          <div className="relative p-3 flex flex-col justify-end h-full gap-2 overflow-y-auto text-white">
            <img
              src={data?.profilePic ?? Images.LogoIconOnly}
              className="h-[2.625em] w-[2.625em] border border-searchBorder shadow-boxContainer rounded-full object-contain bg-white cursor-pointer"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = Images.LogoIconOnly;
              }}
              onClick={(event) => {
                if (event.ctrlKey) {
                  window.open(`/universities/${data.id}`, "_blank");
                } else {
                  navigate(`/universities/${data.id}`);
                }
              }}
            />

            <div className="font-bold text-[0.875em]">{data?.name}</div>
          </div>
        </div>
      </div>
    </Popover>
  );
};

export default ExploreCard;
